import { render, staticRenderFns } from "./userLink.vue?vue&type=template&id=114f9c5c&"
import script from "./userLink.vue?vue&type=script&lang=js&"
export * from "./userLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports